import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css'],
})
export class MyProfileComponent extends BaseCtl {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    var _self = this;
    _self.locator.config
      .getProperty('endpoint.auth')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  override ngOnInit() {
    this.myProfile();
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.phone = data.phone;
    form.gender = data.gender;
    form.dob = data.dob;
    form.email = data.email;
    //form.password = data.password;
    //form.status = data.status;
    //form.role = data.role;
  }

  /**
   * Change password form
   */
  public cpForm = {
    error: false,
    message: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    inputerror: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
  };

  onImageError(event: Event, path: string) {
    const target = event.target as HTMLImageElement;
    target.src = path; // Set path to your default image
  }

  /**
   * Get user profile
   */
  myProfile() {
    var _self = this;

    let url = _self.locator.config.get('endpoint.user') + '/profile';

    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }

      _self.form.message = '';
      _self.form.inputerror = {};

      _self.form.error = !res.success;
      if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
        _self.form.message = res.result.message;
      }

      if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
        _self.form.inputerror = res.result.inputerror;
      }
      if (_self.locator.dataValidator.isTrue(res.success)) {
        _self.form.data = res.result.data;
      }
    });
  }

  /**
   * update user profile
   */
  updateProfile() {
    let _self = this;

    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';

    let authKey = localStorage.getItem(keySuffix + 'skey');

    let url =
      _self.locator.config.get('endpoint.auth') + '/sso/profile/' + authKey;

    this.locator.http.post(
      url,
      this.form.data,
      function (res: any, error: any) {
        if (error) {
          return;
        }
        _self.form.error = !res.success;
        _self.form.message = res.result.message;
        _self.form.inputerror = {};
        if (
          _self.locator.dataValidator.isNotNullObject(res.result.inputerror)
        ) {
          _self.form.inputerror = res.result.inputerror;
        }
      }
    );
  }

  /**
   * Change the password
   *
   * @returns
   */
  changePassword() {
    let _self = this;

    if (_self.cpForm.oldPassword === _self.cpForm.newPassword) {
      _self.cpForm.error = true;
      _self.cpForm.message = 'Old and new password can not be same';
      return;
    }

    if (_self.cpForm.newPassword != _self.cpForm.confirmPassword) {
      _self.cpForm.error = true;
      _self.cpForm.message = 'New and confirm password are not matched';
      return;
    }

    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let authKey = localStorage.getItem(keySuffix + 'skey');

    let url = _self.locator.config.get('endpoint.auth') + '/sso/cp/' + authKey;
    this.locator.http.post(url, this.cpForm, function (res: any, error: any) {
      _self.cpForm.inputerror = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      };
      if (error) {
        return;
      }
      _self.cpForm.error = !res.success;
      _self.cpForm.message = res.message;

      if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
        _self.cpForm.inputerror = res.result.inputerror;
      }
      console.log('cpForm', _self.cpForm);
    });
  }

  parseDate(event: any): Date {
    let dateString = event.target.value;
    // if (dateString) {
    return new Date(dateString);
    // }
    // return null;
  }

  /**
   * Change user image
   *
   * @param fileObj
   */
  onFileChanged(fileObj: any) {
    var _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let authKey = localStorage.getItem(keySuffix + 'skey');
    let ssourl =
      _self.locator.config.get('endpoint.auth') + '/sso/image/' + authKey;

    var param = {
      id: this.form.data.id,
    };
    this.locator.http.postMutipart(
      ssourl,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        _self.form.error = !res.success;
        _self.form.message = res.result.message;
        if (res.success) {
          _self.form.message = 'file is uploaded';
          _self.form.data['imageId'] = res.result.data.imageId;
          _self.changeDoc();
        }
      }
    );
  }
}
